import R from 'ramda';
import React, { Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  FormControl,
  Radio,
  Checkbox,
} from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import getContent from '../ContractBlock/Contents/Consideration';
import Select from '../Select';
import ChangeRequestsView from '../Deals/DealEditPages/ChangeRequestsView';

export default class Consideration extends Component {
  constructor(props) {
    super(props);
    this.state = { adjust: undefined, changes: {} };
  }

  options = () => ({
    payable: this.state.changes.payable,
    royalty: this.state.changes.royalty,
    gratis: this.state.changes.gratis,
    flatFee: this.state.changes.flatFee || 0,
    schedule: this.state.changes.schedule,
    fee: this.state.changes.fee,
    percent: this.state.changes.percent,
    describe: this.state.changes.describe,
    period: this.state.changes.period,
    audit: this.state.changes.audit,
    scheduleDays0: this.state.changes.scheduleDays0,
    scheduleDays1: this.state.changes.scheduleDays1,
    scheduleAmount: this.state.changes.scheduleAmount,
    scheduleAmountDays: this.state.changes.scheduleAmountDays,
    scheduleBalance: this.state.changes.scheduleBalance,
    scheduleBalanceDays: this.state.changes.scheduleBalanceDays,
  });

  componentDidMount() {
    if (this.props.dealBlocks) {
      this.getBlockChanges(this.props.dealBlocks);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dealBlocks) {
      this.getBlockChanges(nextProps.dealBlocks);
    }
  }

  getBlockChanges(dealBlocks) {
    const block = R.find(R.propEq('id', this.props.block.id))(dealBlocks);
    if (block) {
      this.setState({
        changes: block.changes || {},
        adjust: block.accept ? !block.accept : block.changes ? true : undefined,
      });
    }
  }

  handleAdjust(adjust) {
    this.setState({ adjust });

    if (!adjust) {
      this.props.removeBlockChanges(this.props.block.id);
    }
  }

  handleContent(key, value) {
    const options = this.options();

    options[key] = value;

    switch (key) {
      case 'fee':
        options.payable = true;
        break;
      case 'percent':
      case 'describe':
      case 'period':
      case 'audit':
        options.royalty = true;
        break;
      case 'scheduleDays0':
        options.schedule = 0;
        break;
      case 'scheduleDays1':
        options.schedule = 1;
        break;
      case 'scheduleAmount':
      case 'scheduleAmountDays':
      case 'scheduleBalance':
      case 'scheduleBalanceDays':
        options.schedule = 2;
        break;

      default:
        break;
    }

    if (options.payable === true || options.royalty === true) {
      options.gratis = false;
    }

    if (key === 'gratis' && value === true) {
      options.gratis = true;
      options.payable = false;
      options.royalty = false;
    }

    this.props.setBlockChanges({
      id: this.props.block.id,
      options,
      ...getContent(options),
    });
  }

  renderOriginal() {
    let content = '';

    if (this.props.payable === true) {
      content = `The Contributor will be paid a flat fee of $${this.props.fee} or an advance on royalties, if also receiving a royalty.<br/>`;
    }
    if (this.props.royalty === true) {
      content += `The Contributor will receive a royalty.`;
      content += `<p class="answer">`;
      content += `The Contributor will be paid a royalty of ${this.props.percent}% of ${this.props.describe}<br/>`;
      content += `The Owner will account to the Contributor and pay royalties ${this.props.period}<br/>`;
      content += `The Contributor ${this.props.audit} have a right to audit/examine the Owner’s books and records.<br/>`;
      content += `</p>`;
    }
    if (this.props.payable === true) {
      content += `<br /><b>Will the amount paid to the Contributor be a flat fee or an advance that can be recouped with royalties?</b>&nbsp;&nbsp;`;
      if (this.props.flatFee === 0) {
        content += `<span>A flat fee.</span><br />`;
      } else {
        content += `<span>An advance.</span><br />`;
      }

      content += `<br /><b>When will the Contributor be paid?</b>&nbsp;&nbsp;`;
      content += `<span>`;
      if (this.props.schedule === 0) {
        content += `In full, within ${this.props.scheduleDays0} days following full execution of this agreement.`;
      } else if (this.props.schedule === 1) {
        content += `In full, within ${this.props.scheduleDays1} days following the completion and delivery of the services.`;
      } else {
        content += `$${this.props.scheduleAmount} payable within ${this.props.scheduleAmountDays} days following full execution of this agreement, `;
        content += `and the balance $${this.props.scheduleBalance} payable within ${this.props.scheduleBalanceDays} days following the completion and delivery of the services.`;
      }
      content += `</span>`;
    }
    if (this.props.gratis === true) {
      content = `The Contributor is not receiving monetary compensation, but getting other, promotional or marketing value from their contribution.<br/>`;
    }

    return content;
  }

  renderAdjust() {
    const { adjust, changes } = this.state;

    if (adjust === true) {
      return (
        <div className="inner-content">
          <FormGroup className="answer">
            <Checkbox
              name="payable"
              checked={changes.payable === true}
              onClick={(e) => this.handleContent('payable', e.target.checked)}
            >
              The Contributor will be paid a flat fee of $&nbsp;
              <FormControl
                type="number"
                className="input-sm"
                placeholder="$"
                value={changes.fee}
                onChange={(e) => this.handleContent('fee', e.target.value)}
              />
              &nbsp;or an advance on royalties, if also receiving a royalty.
            </Checkbox>
            <Checkbox
              name="royalty"
              checked={changes.royalty === true}
              onChange={(e) => this.handleContent('royalty', e.target.checked)}
            >
              The Contributor will receive a royalty.
            </Checkbox>
            {changes.royalty === true ? (
              <ul>
                <li>
                  <div className="pb1">
                    The Contributor will be paid a royalty of&nbsp;
                    <FormControl
                      type="number"
                      className="input-sm"
                      placeholder="percentage"
                      value={changes.percent}
                      onChange={(e) =>
                        this.handleContent('percent', e.target.value)
                      }
                    />
                    &nbsp;% of&nbsp;
                    <FormControl
                      type="text"
                      className="input-lg"
                      placeholder="what type of revenue stream?"
                      value={changes.describe}
                      onChange={(e) =>
                        this.handleContent('describe', e.target.value)
                      }
                    />
                    .
                  </div>
                </li>
                <li>
                  <div className="pb1">
                    The Owner will account to the Contributor and pay royalties
                    <Select
                      className="select-mini"
                      value={changes.period}
                      onChange={(e) =>
                        this.handleContent('period', e.target.value)
                      }
                    >
                      <option value="">select</option>
                      <option>monthly</option>
                      <option>quarterly</option>
                      <option>semi-annually</option>
                      <option>annually</option>
                    </Select>
                  </div>
                </li>
                <li>
                  <div className="pb1">
                    The Contributor
                    <Select
                      className="select-mini"
                      value={changes.audit}
                      onChange={(e) =>
                        this.handleContent('audit', e.target.value)
                      }
                    >
                      <option value="">select</option>
                      <option>will</option>
                      <option>will not</option>
                    </Select>
                    have a right to audit/examine the Owner’s books and records.
                  </div>
                </li>
              </ul>
            ) : null}
            <Checkbox
              name="gratis"
              checked={changes.gratis === true}
              onClick={(e) => this.handleContent('gratis', e.target.checked)}
            >
              The Contributor is not receiving monetary compensation, but
              getting other, promotional or marketing value from their
              contribution.
            </Checkbox>
          </FormGroup>
          {changes.payable === true ? (
            <div className="answer">
              <p className="question">
                Will the amount paid to the Contributor be a flat fee or an
                advance that can be recouped with royalties?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="flatFee"
                  checked={changes.flatFee === 0}
                  readOnly
                  onClick={(e) => this.handleContent('flatFee', 0)}
                >
                  A flat fee.
                </Radio>
                <Radio
                  name="flatFee"
                  checked={changes.flatFee === 1}
                  readOnly
                  onClick={(e) => this.handleContent('flatFee', 1)}
                >
                  An advance.
                </Radio>
              </FormGroup>
              <p className="question">When will the Contributor be paid?</p>
              <FormGroup className="answer">
                <Radio
                  name="schedule"
                  checked={changes.schedule === 0}
                  readOnly
                  onClick={(e) => this.handleContent('schedule', 0)}
                >
                  In full, within&nbsp;
                  <FormControl
                    type="number"
                    className="input-sm"
                    placeholder="DAYS"
                    value={changes.scheduleDays0}
                    onChange={(e) =>
                      this.handleContent('scheduleDays0', e.target.value)
                    }
                  />
                  &nbsp;days following full execution of this agreement.
                </Radio>
                <Radio
                  name="schedule"
                  checked={changes.schedule === 1}
                  readOnly
                  onClick={(e) => this.handleContent('schedule', 1)}
                >
                  In full, within&nbsp;
                  <FormControl
                    type="number"
                    className="input-sm"
                    placeholder="DAYS"
                    value={changes.scheduleDays1}
                    onChange={(e) =>
                      this.handleContent('scheduleDays1', e.target.value)
                    }
                  />
                  &nbsp;days following the completion and delivery of the
                  services.
                </Radio>
                <Radio
                  name="schedule"
                  checked={changes.schedule === 2}
                  readOnly
                  onClick={(e) => this.handleContent('schedule', 2)}
                >
                  $&nbsp;
                  <FormControl
                    type="number"
                    className="input-sm"
                    placeholder="AMOUNT"
                    value={changes.scheduleAmount}
                    onChange={(e) =>
                      this.handleContent('scheduleAmount', e.target.value)
                    }
                  />
                  &nbsp;payable within&nbsp;
                  <FormControl
                    type="number"
                    className="input-sm"
                    placeholder="DAYS"
                    value={changes.scheduleAmountDays}
                    onChange={(e) =>
                      this.handleContent('scheduleAmountDays', e.target.value)
                    }
                  />
                  &nbsp;days following full execution of this agreement, and the
                  balance $&nbsp;
                  <FormControl
                    type="number"
                    className="input-sm"
                    placeholder="BALANCE"
                    value={changes.scheduleBalance}
                    onChange={(e) =>
                      this.handleContent('scheduleBalance', e.target.value)
                    }
                  />
                  &nbsp;payable within&nbsp;
                  <FormControl
                    type="number"
                    className="input-sm"
                    placeholder="DAYS"
                    value={changes.scheduleBalanceDays}
                    onChange={(e) =>
                      this.handleContent('scheduleBalanceDays', e.target.value)
                    }
                  />
                  &nbsp;days following the completion and delivery of the
                  services.
                </Radio>
              </FormGroup>
            </div>
          ) : null}
        </div>
      );
    } else {
      return null;
    }
  }

  renderChangeRequest(changeRequest) {
    let content = '';

    if (changeRequest.changes.payable === true) {
      content = `The Contributor will be paid a flat fee of $${changeRequest.changes.fee} or an advance on royalties, if also receiving a royalty.<br/>`;
    }
    if (changeRequest.changes.royalty === true) {
      content += `The Contributor will receive a royalty.`;
      content += `<p class="answer">`;
      content += `The Contributor will be paid a royalty of ${changeRequest.changes.percent}% of ${changeRequest.changes.describe}<br/>`;
      content += `The Owner will account to the Contributor and pay royalties ${changeRequest.changes.period}<br/>`;
      content += `The Contributor ${changeRequest.changes.audit} have a right to audit/examine the Owner’s books and records.<br/>`;
      content += `</p>`;
    }
    if (changeRequest.changes.payable === true) {
      content += `<b class="text-black">Will the amount paid to the Contributor be a flat fee or an advance that can be recouped with royalties?</b><br/>`;
      if (changeRequest.changes.flatFee === 0) {
        content += `<p class="answer">A flat fee.</p>`;
      } else {
        content += `<p class="answer">An advance.</p>`;
      }

      content += `<b class="text-black">When will the Contributor be paid?</b>`;
      content += `<p class="answer">`;
      if (changeRequest.changes.schedule === 0) {
        content += `In full, within ${changeRequest.changes.scheduleDays0} days following full execution of this agreement.`;
      } else if (changeRequest.changes.schedule === 1) {
        content += `In full, within ${changeRequest.changes.scheduleDays1} days following the completion and delivery of the services.`;
      } else {
        content += `$${changeRequest.changes.scheduleAmount} payable within ${changeRequest.changes.scheduleAmountDays} days following full execution of this agreement, `;
        content += `and the balance $${changeRequest.changes.scheduleBalance} payable within ${changeRequest.changes.scheduleBalanceDays} days following the completion and delivery of the services.`;
      }
      content += `</p>`;
    }
    if (changeRequest.changes.gratis === true) {
      content = `The Contributor is not receiving monetary compensation, but getting other, promotional or marketing value from their contribution.<br/>`;
    }

    return content;
  }

  renderChangeRequests() {
    return (
      <ChangeRequestsView
        changeRequests={this.props.changeRequests}
        renderChangeRequest={(changeRequest) =>
          this.renderChangeRequest(changeRequest)
        }
        isHTML
      />
    );
  }

  render() {
    return (
      <div className="tab-content">
        <Row>
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>
              <p className="question">
                How will the Contributor be compensated for their contribution?
              </p>
              <FormGroup className="answer">
                <Radio
                  name="consideraion-adjust"
                  checked={this.state.adjust === false}
                  readOnly
                  onClick={(e) => this.handleAdjust(false)}
                >
                  {this.props.userInfo.same
                    ? `Keep my original proposal: `
                    : `Accept ${this.props.userInfo.name} 's proposed terms: `}
                  <div
                    className="pt-7px"
                    dangerouslySetInnerHTML={{ __html: this.renderOriginal() }}
                  ></div>
                </Radio>
                <hr />
                <Radio
                  name="consideraion-adjust"
                  checked={this.state.adjust === true}
                  readOnly
                  onClick={(e) => this.handleAdjust(true)}
                >
                  {this.props.userInfo.same
                    ? `Change my proposal:`
                    : `Suggest an alternative:`}
                </Radio>
              </FormGroup>
              {this.renderAdjust()}
              {this.props.renderAccepts()}
              {this.renderChangeRequests()}
            </Col>
          )}
          {!this.props.finalized && !this.props.isAttorney && (
            <Col sm={12}>{this.props.children}</Col>
          )}

          <Col sm={12}>
            <div className="notes">
              <h4>
                <FontAwesome name="question-circle" />
                Need Some Help?
              </h4>
              <div className="expand" tabIndex="0">
                <p className="question">Why is this important?</p>
                <p className="small">
                  "Consideration" is the payment of something of value to the
                  independent contractor in exchange for the work they have
                  done. This section defines what the consideration is and the
                  payment schedule.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What is an "advance"?</p>
                <p className="small">
                  An "advance" is an upfront payment of money that is offset in
                  the future by royalties or other types of income.
                </p>
              </div>
              <div className="expand" tabIndex="0">
                <p className="question">What does “recoup” mean?</p>
                <p className="small">
                  "Recoup" is short for "recuperation" and means to be
                  compensated for something that has been paid out, such as an
                  advance.
                </p>
              </div>
              {/* <p className="small">
                                <strong>Text Box A</strong>: Enter a percentage (numerical value)
                                </p>
                                <p className="small">
                                <strong>Text Box B</strong>: Describe the kind(s) of exploitation that the Contributor will earn royalties from. <br/>
                                Examples: ”all exploitations of the Work(s).” “sales of the works” “synch license fees from the Work(s)”, etc.
                            </p> */}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/components/DealContractBlock/Consideration.jsx